import { render, staticRenderFns } from "./PrivacyDrawer.vue?vue&type=template&id=61a75dbd&scoped=true"
import script from "./PrivacyDrawer.vue?vue&type=script&lang=js"
export * from "./PrivacyDrawer.vue?vue&type=script&lang=js"
import style0 from "./PrivacyDrawer.vue?vue&type=style&index=0&id=61a75dbd&prod&scoped=true&lang=scss"
import style1 from "./PrivacyDrawer.vue?vue&type=style&index=1&id=61a75dbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a75dbd",
  null
  
)

export default component.exports